import {
  axios_nomination,
} from '@/plugins/axios';

import configuration from '@/configurations';

class CreditRepository {
  constructor() {
    this.calls_in_progress = {};
  }

  static get CONTACT_ITEM_TYPE_ID() {
    return 2;
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getCreditSequenceUsers(criteria) {
    const {
      organization_id,
      subscription_last_date,
    } = criteria;

    const key = `getCreditSequenceUsers:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}/users`,
        {
          params: {
            subscription_last_date,
          },
        }
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getOrganizationCampaignCredits(criteria) {
    const {
      organization_id,
    } = criteria;

    const key = `getOrganizationCampaignCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getOrganizationConsultationCredits(criteria) {
    const {
      organization_id,
    } = criteria;

    const key = `getOrganizationConsultationCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/consultation/organization/${organization_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getOrganizationConnectorCredits(criteria) {
    const {
      organization_id,
    } = criteria;

    const key = `getOrganizationConnectorCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/connector/organization/${organization_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUserConsultationCredits(criteria) {
    const {
      organization_id,
      user_id,
    } = criteria;

    const key = `getUserConsultationCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/consultation/organization/${organization_id}/user/${user_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getCampaignCredits(criteria) {
    const {
      organization_id,
    } = criteria;

    const key = `getCampaignCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUserCampaignCredits(criteria) {
    const {
      organization_id,
      user_id,
    } = criteria;

    const key = `getUserCampaignCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}/user/${user_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUserEmailRentalCredits(criteria) {
    const {
      organization_id,
      user_id,
    } = criteria;

    const key = `getUserEmailRentalCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/email-rental/organization/${organization_id}/user/${user_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUserExportCredits(criteria) {
    const {
      organization_id,
      user_id,
    } = criteria;

    const key = `getUserExportCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/export/organization/${organization_id}/user/${user_id}`
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUsersCampaignCredits(criteria) {
    const {
      organization_id,
      params,
    } = criteria;

    const key = `getUsersCampaignCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}/users`,
        {
          params,
        }
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUsersEmailRentalCredits(criteria) {
    const {
      organization_id,
      params,
    } = criteria;

    const key = `getUsersEmailRentalCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/email-rental/organization/${organization_id}/users`,
        {
          params,
        }
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   * @param {Object} criteria
   * @returns {Promise}
   */
  async getUsersExportCredits(criteria) {
    const {
      organization_id,
      params,
    } = criteria;

    const key = `getUsersExportCredits:${btoa(JSON.stringify(criteria))}`;

    if (this.calls_in_progress[key]) {
      return this.calls_in_progress[key];
    }

    this.calls_in_progress[key] = axios_nomination
      .get(
        `${configuration.api_host}/v1/credits/export/organization/${organization_id}/users`,
        {
          params,
        }
      )
      .then((response) => response.data)
      .finally(() => {
        delete this.calls_in_progress[key];
      });

    return this.calls_in_progress[key];
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async createCampaignCredits(organization_id, user_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}/user/${user_id}`,
      data
    );

    return response.data;
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async updateCampaignCredits(organization_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/sequence/organization/${organization_id}/manage`,
      data
    );

    return response.data;
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async createEmailRentalredits(organization_id, user_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/email-rental/organization/${organization_id}/user/${user_id}`,
      data
    );

    return response.data;
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async updateEmailRentalredits(organization_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/email-rental/organization/${organization_id}/manage`,
      data
    );

    return response.data;
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async createExportCredits(organization_id, user_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/export/organization/${organization_id}/user/${user_id}`,
      data
    );

    return response.data;
  }

  /**
   *
   * @param {Number} organization_id
   * @param {Object} data
   *
   * @returns {Promise<Object>}
   */
  async updateExportCredits(organization_id, data) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/export/organization/${organization_id}/manage`,
      data
    );

    return response.data;
  }

  async withdrawContactConsultationCredit(input) {
    const response = await axios_nomination.post(
      `${configuration.api_host}/v1/credits/withdrawals`,
      {
        ...input,
        comment: '',
        entity_type_id: CreditRepository.CONTACT_ITEM_TYPE_ID,
      }
    );

    return response.data;
  }
}

const credit_repository = new CreditRepository();

export {
  credit_repository,
};
